module.exports = __webpack_public_path__ + "static/ITSEC_2024-fd631fed850a71d9fa82fc1068ff1947.jpeg";